function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RNDateTimePicker from "@react-native-community/datetimepicker";
import noop from "lodash/noop";
import { useState } from "react";
import { Platform, StyleSheet, TouchableWithoutFeedback } from "react-native";
import DateTimePicker from "react-native-modal-datetime-picker";
import { Menu, MenuOptions, MenuTrigger, renderers } from "react-native-popup-menu";
import { formatGQLDate, parseGQLDateTime } from "@oui/lib/src/gqlDate";
import { parseHoursAndMinutes } from "@oui/lib/src/parseHoursAndMinutes";
import { useAppContext } from "./AppContext";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { TextInput } from "./TextInput";
import { View } from "./View";
import { WebDatePickerInner } from "./WebDatePickerInner";
import { IOS_14_OR_GREATER } from "../constants";
import { AccessibleInput } from "../hooks/useAccessibleInput";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
/**
 * @nosync
 */ export var IOSDateTimeInputHeader = function(param) {
    var mode = param.mode;
    var $t = useI18n().$t;
    var label = mode === 'time' ? $t({
        id: 'DateTimeInput_timeHeading',
        defaultMessage: 'Pick a time'
    }) : $t({
        id: 'DateTimeInput_dateHeading',
        defaultMessage: 'Pick a date'
    });
    return /*#__PURE__*/ _jsx(View, {
        style: {
            borderBottomColor: '#d5d5d5',
            borderBottomWidth: StyleSheet.hairlineWidth,
            padding: 14,
            backgroundColor: 'transparent'
        },
        children: /*#__PURE__*/ _jsx(Text, {
            size: 18,
            weight: "semibold",
            color: '#8f8f8f',
            textAlign: "center",
            text: label
        })
    });
};
/**
 * Allows the user to input dates, datetimes, and times depending on the
 * specified `mode`.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-77}
 */ export function DateTimeInput(_param) {
    var ariaLabel = _param['aria-label'], disabled = _param.disabled, error = _param.error, label = _param.label, _param_mode = _param.mode, mode = _param_mode === void 0 ? 'datetime' : _param_mode, _param_minuteInterval = _param.minuteInterval, minuteInterval = _param_minuteInterval === void 0 ? 15 : _param_minuteInterval, onChangeValue = _param.onChangeValue, placeholder = _param.placeholder, style = _param.style, value = _param.value, variant = _param.variant, testID = _param.testID, props = _object_without_properties(_param, [
        'aria-label',
        "disabled",
        "error",
        "label",
        "mode",
        "minuteInterval",
        "onChangeValue",
        "placeholder",
        "style",
        "value",
        "variant",
        "testID"
    ]);
    var theme = useTheme().theme;
    var _useState = _sliced_to_array(useState(false), 2), isVisible = _useState[0], setIsVisible = _useState[1];
    var flags = useAppContext().flags;
    var _useI18n = useI18n(), formatDate = _useI18n.formatDate, formatTime = _useI18n.formatTime, $t = _useI18n.$t;
    var date = value ? mode === 'time' ? parseHoursAndMinutes(value) : parseGQLDateTime(value) : undefined;
    function onDateChange(newDate) {
        // This should be called before onChangeValue to prevent the DateTimePicker from re-appearing
        // on android
        // https://github.com/ouihealth/oui/issues/733
        setIsVisible(false);
        if (onChangeValue) {
            if (mode === 'time') {
                var hoursMinutes = formatDate(newDate, {
                    hour: '2-digit',
                    minute: '2-digit',
                    hourCycle: 'h23'
                });
                onChangeValue(hoursMinutes);
            } else {
                onChangeValue(mode === 'datetime' ? newDate.toISOString() : formatGQLDate(newDate));
            }
        }
    }
    var dateValue = date ? mode === 'datetime' ? formatDate(date, _object_spread({
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    }, props.formatOptions)) : mode === 'date' ? formatDate(date, _object_spread({
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }, props.formatOptions)) : formatTime(date, _object_spread({
        hour: 'numeric',
        minute: 'numeric'
    }, props.formatOptions)) : '';
    if (global.e2e && Platform.OS === 'android') {
        var _date_toISOString;
        return /*#__PURE__*/ _jsx(View, {
            style: style,
            children: /*#__PURE__*/ _jsx(TextInput, {
                testID: testID,
                label: label,
                onChangeValue: function(v) {
                    onDateChange(parseGQLDateTime(v));
                },
                value: (_date_toISOString = date === null || date === void 0 ? void 0 : date.toISOString()) !== null && _date_toISOString !== void 0 ? _date_toISOString : ''
            })
        });
    }
    return /*#__PURE__*/ _jsx(AccessibleInput, {
        placeholder: placeholder,
        error: error,
        "aria-label": ariaLabel,
        label: label,
        style: style,
        testID: testID,
        children: function(accessibleProps) {
            return /*#__PURE__*/ _jsxs(Menu, {
                opened: isVisible,
                onBackdropPress: function() {
                    return setIsVisible(false);
                },
                renderer: renderers.ContextMenu,
                children: [
                    /*#__PURE__*/ _jsx(MenuTrigger, {
                        children: /*#__PURE__*/ _jsx(TouchableWithoutFeedback, _object_spread_props(_object_spread({
                            onPress: function() {
                                return setIsVisible(true);
                            },
                            testID: testID
                        }, accessibleProps), {
                            "aria-label": (dateValue ? "".concat(dateValue, ".") : '') + accessibleProps['aria-label'] + " ".concat(mode, " picker"),
                            onAccessibilityAction: function(event) {
                                switch(event.nativeEvent.actionName){
                                    case 'activate':
                                        setIsVisible(true);
                                        break;
                                }
                            },
                            children: /*#__PURE__*/ _jsxs(View, {
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        pointerEvents: "box-only",
                                        "aria-hidden": true,
                                        children: [
                                            /*#__PURE__*/ _jsx(TextInput, {
                                                onChangeValue: noop,
                                                placeholder: placeholder,
                                                variant: variant,
                                                value: dateValue,
                                                readOnly: true
                                            }),
                                            mode === 'date' ? /*#__PURE__*/ _jsx(Icon, {
                                                name: "calendar",
                                                style: {
                                                    position: 'absolute',
                                                    top: '50%',
                                                    right: 20,
                                                    transform: [
                                                        {
                                                            translateY: -10
                                                        }
                                                    ]
                                                },
                                                color: theme.color.gray500
                                            }) : mode === 'time' ? /*#__PURE__*/ _jsx(Icon, {
                                                name: "clock",
                                                style: {
                                                    position: 'absolute',
                                                    top: '50%',
                                                    right: 20,
                                                    transform: [
                                                        {
                                                            translateY: -10
                                                        }
                                                    ]
                                                },
                                                color: theme.color.gray500
                                            }) : null
                                        ]
                                    }),
                                    flags.useIOS14DatePicker && IOS_14_OR_GREATER ? /*#__PURE__*/ _jsx(RNDateTimePicker, {
                                        accessible: false,
                                        value: date !== null && date !== void 0 ? date : new Date(),
                                        style: [
                                            StyleSheet.absoluteFillObject,
                                            {
                                                height: 56,
                                                opacity: 0.02,
                                                zIndex: 1
                                            }
                                        ],
                                        mode: mode,
                                        display: "compact",
                                        onChange: function(_, newDate) {
                                            return newDate && onDateChange(newDate);
                                        }
                                    }) : null
                                ]
                            })
                        }))
                    }),
                    Platform.OS !== 'web' ? /*#__PURE__*/ _jsx(MenuOptions, {
                        customStyles: {}
                    }) : null,
                    Platform.OS !== 'web' ? /*#__PURE__*/ _jsx(DateTimePicker, _object_spread_props(_object_spread({}, props), {
                        display: IOS_14_OR_GREATER ? 'spinner' : undefined,
                        customHeaderIOS: function() {
                            return /*#__PURE__*/ _jsx(IOSDateTimeInputHeader, {
                                mode: mode
                            });
                        },
                        date: date,
                        mode: mode,
                        isVisible: isVisible,
                        onConfirm: onDateChange,
                        onCancel: function() {
                            setIsVisible(false);
                        },
                        minuteInterval: minuteInterval,
                        testID: "DateTimePicker",
                        cancelTextIOS: $t({
                            id: 'DateTimeInput_cancelButton',
                            defaultMessage: 'Cancel'
                        }),
                        confirmTextIOS: $t({
                            id: 'DateTimeInput_confirmButton',
                            defaultMessage: 'Confirm'
                        })
                    })) : /*#__PURE__*/ _jsx(MenuOptions, {
                        customStyles: {},
                        children: /*#__PURE__*/ _jsx(WebDatePickerInner, {
                            mode: mode,
                            date: date || new Date(),
                            onDateChange: onDateChange,
                            onCancel: function() {
                                return setIsVisible(false);
                            },
                            minuteInterval: minuteInterval,
                            minimumDate: props.minimumDate,
                            maximumDate: props.maximumDate
                        })
                    })
                ]
            });
        }
    });
}
